import axios from "axios";

const sendQuery = async ({ email, description, file, fileType }) => {
  try {
    let token = localStorage.getItem("token");
    let { data } = await axios.post(
      `https://godrej.app-assertai.com:5000/support/sendquery`,
      {
        email: email,
        description: description,
        file,
        fileType,
      },
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export { sendQuery };
